import { CommonAction } from '../../../login/redux/types';
import ReferralsTypes, { ReferralData } from './types';

function getReferralDetail(investmentUUID: string): CommonAction {
    return {
        type: ReferralsTypes.GET_REFERRALS_REQ,
        payload: investmentUUID,
    };
}

function setReferralDetail(referrals: ReferralData[]): CommonAction {
    return {
        type: ReferralsTypes.SET_REFERRALS,
        payload: referrals,
    };
}


const ReferralsActions = {
    getReferralDetail,
    setReferralDetail,
};

export default ReferralsActions;
